export default __webpack_public_path__ + "static/subset-UniNeueLight-Italic-8b7d7ca17a034188e06d6644eda97278.woff";